<template>
  <div>
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="green">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog.freeze"
      @keydown.esc="dialog.freeze = false"
      :fullscreen="dialog.fullscreen"
      width="400"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Freeze Kolom

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="py-0">
          <v-form>
            <v-row>
              <v-col>
                <div>
                  <p class="mb-2">
                    Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                  </p>

                  <v-list-item-group
                    multiple>
                    <v-list flat>
                      <v-list-item 
                        v-for="(item, index) in configHeaders" 
                        :key="index"
                        class="px-0"
                        @click="item.freeze = !item.freeze ? true : false">
                        <v-list-item-action class="mr-4">
                          <v-checkbox
                            :color="set_color"
                            :input-value="item.freeze">
                          </v-checkbox>
                        </v-list-item-action>

                        <v-list-item-content>
                          <p
                            class="mb-0"
                            :class="item.freeze ? 'font-weight-bold' : ''"
                            :style="item.freeze ? `color: ${set_color};` : ''">
                            {{ item.text }}
                          </p>
                        </v-list-item-content>
                      </v-list-item>  
                    </v-list>
                  </v-list-item-group>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            :color="set_color"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Freeze
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.hide"
      @keydown.esc="dialog.hide = false"
      :fullscreen="dialog.fullscreen"
      width="400"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Hide Kolom

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.hide = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="py-0">
          <v-form>
            <v-row>
              <v-col>
                <div>
                  <p class="mb-2">
                    Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                  </p>

                  <v-list-item-group
                    multiple>
                    <v-list flat>
                      <v-list-item 
                        v-for="(item, index) in headers" 
                        :key="index"
                        class="px-0"
                        @click="item.hide = !item.hide ? true : false">
                        <v-list-item-action class="mr-4">
                          <v-checkbox
                            :color="set_color"
                            :input-value="item.hide">
                          </v-checkbox>
                        </v-list-item-action>

                        <v-list-item-content>
                          <p
                            class="mb-0"
                            :class="item.hide ? 'font-weight-bold' : ''"
                            :style="item.hide ? `color: ${set_color};` : ''">
                            {{ item.text }}
                          </p>
                        </v-list-item-content>
                      </v-list-item>  
                    </v-list>
                  </v-list-item-group>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            :color="set_color"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Hide
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.form"
      @keydown.esc="dialog.form = false"
      :fullscreen="dialog.fullscreen"
      width="650"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          {{ form.id === '' ? 'Tambah' : 'Ubah' }}

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.form = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text
          class="mt-4">
          <ValidationObserver 
            ref="form">
            <v-form>
              <ValidationProvider 
                name="Kode Asset Manual" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                 <span class="red--text">*</span>
                  Kode Asset Manual
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  hide-details

                  placeholder="Contoh. MK-001"

                  v-model="form.code_manual"
                  :success="form.code_manual !== '' && valid"
                  :error-messages="errors"
                  class="mb-6"
                  style="border-radius: 10px; width: 50%;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Kode Asset Manual {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.code_manual !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="Lokasi" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                 <span class="red--text">*</span>
                  Lokasi
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  hide-details
                  placeholder="Contoh. Gedung A Lantai 1"

                  v-model="form.location_name"
                  :success="form.location_name !== '' && valid"
                  :error-messages="errors"
                  class="mb-6"
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Lokasi {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.location_name !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="PIC" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                 <span class="red--text">*</span>
                  PIC
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  hide-details
                  placeholder="Contoh. Budi Santoso"

                  v-model="form.pic_name"
                  :success="form.pic_name !== '' && valid"
                  :error-messages="errors"
                  class="mb-6"
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        PIC {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.pic_name !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="year" 
                rules="required"
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Tahun Pengadaan
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-select
                  v-on:keyup.enter="save_import()"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Pilih Tahun"
                  hide-details
                  
                  :items="years"
                  item-text="text"
                  item-value="value"
                  :item-color="set_color"

                  v-model="form.tahun_pengadaan"
                  :success="form.tahun_pengadaan !== '' && valid"
                  :error-messages="errors"
                  class="mb-6"
                  style="border-radius: 10px; width: 40%;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Tahun Pengadaan {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.tahun_pengadaan !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>

              <ValidationProvider 
                name="Harga" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Nilai Beli
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-currency-field
                  type="number"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"

                  :min="0"
                  filled
                  rounded
                  dense
                  :color="set_color"

                  @focus="$event.target.select()"

                  hide-details

                  v-model.number="form.nilai_beli"
                  :success="form.nilai_beli !== '' && valid"
                  :error-messages="errors"
                  class="mb-6"
                  style="border-radius: 10px; width: 60%;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Nilai Beli {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.nilai_beli !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-currency-field>
              </ValidationProvider>

              <div class="body-2">
                <span class="red--text">*</span>
                Lampiran
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>

              <v-row>
                <v-col
                  v-for="(item, index) in form.attachments_json_array"
                  :key="index"
                  cols="12"
                  md="6">
                  <v-card 
                    flat
                    height="250"
                    class="d-flex align-center justify-center cursor-pointer"
                        style="border-radius: 10px;
                              border: 2px solid #eaeaea; 
                              border-style: dashed;">
                    <v-img 
                      width="100%"
                      height="100%"
                      alt="visuality" 
                      :src="item.url !== '' ? item.url : require('@/assets/image/image_default.png')"
                      class="ma-auto"
                      style="border-radius: 10px;">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>

                    <v-icon 
                      @click="form.attachments_json_array.splice(index, 1)"
                      color="red"
                      class="cursor-pointer"
                      style="position: absolute; top: -8px; right: -8px;">
                      mdi-close-circle
                    </v-icon>
                  </v-card>
                </v-col>

                <v-col
                  cols="12"
                  md="6">
                  <uploadfolder 
                    v-model="upload.image">
                    <div 
                      slot="activator">
                      <v-card 
                        flat
                        height="250"
                        class="d-flex align-center justify-center cursor-pointer"
                        style="border-radius: 10px;
                              border: 2px solid #eaeaea; 
                              border-style: dashed;">
                        <v-avatar v-if="!process.image"
                          v-ripple
                          tile 
                          width="100%"
                          height="250">
                          <v-icon
                            size="75"
                            color="#B9B9B9">
                            mdi-plus-circle-outline
                          </v-icon>
                        </v-avatar>

                        <v-progress-circular v-else
                          indeterminate
                          :color="set_color">
                        </v-progress-circular>
                      </v-card>
                    </div>
                  </uploadfolder>
                </v-col>
              </v-row>
            </v-form>
          </ValidationObserver>

          <div v-if="message.error.length > 0"
            class="text-center my-4">
            <div
              class="error--text d-flex align-start">
              <v-icon size="18" color="red" class="mt-1">mdi-alert-circle-outline</v-icon>
              
              <span
                class="ml-1">
                {{ message.error }}
              </span>
            </div>
          </div>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save()"
            @click="save()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.form = false; reset();">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.update_pemeliharaan"
      @keydown.esc="dialog.update_pemeliharaan = false"
      :fullscreen="dialog.fullscreen"
      width="650"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Ubah Tanggal Pemeliharaan Terakhir

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.update_pemeliharaan = false; dialog.fullscreen = false; selected.update_pemeliharaan = [];"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text 
          class="mt-4">
          <ValidationObserver 
            ref="form">
            <v-form>
              <div>
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Tanggal Pemeliharaan Terakhir
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-menu
                  ref="last"
                  min-width="290px"
                  max-width="290px"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  :close-on-content-click="false"
                  v-model="picker.last">
                  <template v-slot:activator="{ on, attrs }">
                    <ValidationProvider 
                      name="Tanggal Pemeliharaan Terakhir" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <v-text-field
                        readonly
                        filled
                        rounded
                        dense
                        :color="set_color"
                        placeholder="Pilih Tanggal"
                        hide-details
                        clearable

                        @click:clear="form_pemeliharaan.last_maintenance_date = null;"
                        v-on="on"
                        v-bind="attrs"

                        v-model="form_pemeliharaan.last_maintenance_date"
                        :success="form_pemeliharaan.last_maintenance_date !== '' && form_pemeliharaan.last_maintenance_date !== null && valid"
                        :error-messages="errors"
                        class="mb-6"
                        style="border-radius: 10px; width: 50%;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Tanggal Pemeliharaan Terakhir {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form_pemeliharaan.last_maintenance_date !== '' && form_pemeliharaan.last_maintenance_date !== null && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </template>

                  <v-date-picker 
                    :color="set_color"
                    v-model="form_pemeliharaan.last_maintenance_date"
                    @input="picker.last = false">
                  </v-date-picker>
                </v-menu>
              </div>

              <div
                class="font-weight-bold black--text">
                Jadwal Pemeliharaan
              </div>

              <v-row>
                <v-col
                  cols="12"
                  md="7">
                  <ValidationProvider 
                    name="Jadwal" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Jadwal
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>

                    <v-select
                      v-on:keyup.enter="save_import()"
                      filled
                      rounded
                      dense
                      :color="set_color"
                      placeholder="Contoh. Mingguan"
                      hide-details
                      
                      :items="[
                        {
                          text: 'Harian',
                          value: 'daily'
                        },
                        {
                          text: 'Mingguan',
                          value: 'weekly'
                        },
                        {
                          text: 'Bulanan',
                          value: 'monthly'
                        },
                        {
                          text: 'Tahunan',
                          value: 'annual'
                        }
                      ]"
                      item-text="text"
                      item-value="value"
                      :item-color="set_color"

                      v-model="form_pemeliharaan.maintenance_schedule_type"
                      :success="form_pemeliharaan.maintenance_schedule_type !== '' && valid"
                      :error-messages="errors"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            Jadwal {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form_pemeliharaan.maintenance_schedule_type !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-select>
                  </ValidationProvider>
                </v-col>

                <v-col
                  cols="12"
                  md="5">
                  <ValidationProvider 
                    name="Jumlah" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                    <span class="red--text">*</span>
                      Jumlah
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>

                    <v-text-field
                      filled
                      rounded
                      dense
                      :color="set_color"
                      hide-details
                      type="number"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      min="0"

                      placeholder="Contoh. 1"

                      v-model="form_pemeliharaan.maintenance_schedule_value"
                      :success="form_pemeliharaan.maintenance_schedule_value !== '' && valid"
                      :error-messages="errors"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            Jumlah {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form_pemeliharaan.maintenance_schedule_value !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-form>
          </ValidationObserver>
        </v-card-text>

        <div v-if="message.error.length > 0"
          class="text-center my-4">
          <div
            class="error--text d-flex align-start">
            <v-icon size="18" color="red" class="mt-1">mdi-alert-circle-outline</v-icon>
            
            <span
              class="ml-1">
              {{ message.error }}
            </span>
          </div>
        </div>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            @click="updates()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Ya, Ubah Tanggal Pemeliharaan Terakhir
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.update_pemeliharaan = false; dialog.fullscreen = false; selected.update_pemeliharaan = [];">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.delete"
      @keydown.esc="dialog.delete = false"
      :fullscreen="dialog.fullscreen"
      width="650"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Hapus Data

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text 
          class="mt-4">
          <ValidationObserver 
            ref="form">
            <v-form>
              <div>
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Tanggal
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-menu
                  ref="delete"
                  min-width="290px"
                  max-width="290px"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  :close-on-content-click="false"
                  v-model="picker.delete">
                  <template v-slot:activator="{ on, attrs }">
                    <ValidationProvider 
                      name="Tanggal" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <v-text-field
                        readonly
                        filled
                        rounded
                        dense
                        :color="set_color"
                        placeholder="Pilih Tanggal"
                        hide-details
                        clearable

                        @click:clear="form_delete.date = null;"
                        v-on="on"
                        v-bind="attrs"

                        v-model="form_delete.date"
                        :success="form_delete.date !== '' && form_delete.date !== null && valid"
                        :error-messages="errors"
                        class="mb-6"
                        style="border-radius: 10px; width: 50%;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Tanggal {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form_delete.date !== '' && form_delete.date !== null && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </template>

                  <v-date-picker 
                    :color="set_color"
                    v-model="form_delete.date"
                    @input="picker.delete = false">
                  </v-date-picker>
                </v-menu>
              </div>

              <ValidationProvider 
                name="Keterangan" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Keterangan
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>
                
                <v-textarea
                  filled
                  rounded
                  dense
                  :color="set_color"

                  rows="3"
                  
                  placeholder="Contoh. Tidak masuk dalam pemeliharaan"
                  hide-details

                  v-model="form_delete.desc"
                  :success="valid"
                  :error-messages="errors"
                  required
                  class="mb-6"
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Keterangan {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form_delete.desc !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-textarea>
              </ValidationProvider>

              <div class="body-2">
                <span class="red--text">*</span>
                Lampiran
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>

              <v-row>
                <v-col
                  v-for="(item, index) in form_delete.attachments_json_array"
                  :key="index"
                  cols="12"
                  md="6">
                  <v-card 
                    flat
                    height="250"
                    class="d-flex align-center justify-center cursor-pointer"
                        style="border-radius: 10px;
                              border: 2px solid #eaeaea; 
                              border-style: dashed;">
                    <v-img 
                      width="100%"
                      height="100%"
                      alt="visuality" 
                      :src="item.url !== '' ? item.url : require('@/assets/image/image_default.png')"
                      class="ma-auto"
                      style="border-radius: 10px;">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>

                    <v-icon 
                      @click="form_delete.attachments_json_array.splice(index, 1)"
                      color="red"
                      class="cursor-pointer"
                      style="position: absolute; top: -8px; right: -8px;">
                      mdi-close-circle
                    </v-icon>
                  </v-card>
                </v-col>

                <v-col
                  cols="12"
                  md="6">
                  <uploadfolder 
                    v-model="upload.image">
                    <div 
                      slot="activator">
                      <v-card 
                        flat
                        height="250"
                        class="d-flex align-center justify-center cursor-pointer"
                        style="border-radius: 10px;
                              border: 2px solid #eaeaea; 
                              border-style: dashed;">
                        <v-avatar v-if="!process.image"
                          v-ripple
                          tile 
                          width="100%"
                          height="250">
                          <v-icon
                            size="75"
                            color="#B9B9B9">
                            mdi-plus-circle-outline
                          </v-icon>
                        </v-avatar>

                        <v-progress-circular v-else
                          indeterminate
                          :color="set_color">
                        </v-progress-circular>
                      </v-card>
                    </div>
                  </uploadfolder>
                </v-col>
              </v-row>
            </v-form>
          </ValidationObserver>
        </v-card-text>

        <div v-if="message.error.length > 0"
          class="text-center my-4">
          <div
            class="error--text d-flex align-start">
            <v-icon size="18" color="red" class="mt-1">mdi-alert-circle-outline</v-icon>
            
            <span
              class="ml-1">
              {{ message.error }}
            </span>
          </div>
        </div>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.delete"
            :loading="process.delete"
            @click="deletes()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Ya, Hapus
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.delete"
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.qrcode"
      @keydown.esc="dialog.qrcode = false"
      :fullscreen="dialog.fullscreen"
      width="700"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          QR Kode

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.qrcode = false; dialog.fullscreen = false; selected.row = [];"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text v-if="selected.row.length > 0"
          class="mt-4">
          <div
            class="d-flex justify-center ">
            <qr-code 
              id="download_qr"
              :text="selected.row[0].code"
              :size="rps !== 'lg' ? 300 : 600">
            </qr-code>
          </div>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            @click="dialog.qrcode = false; dialog.fullscreen = false; selected.row = [];">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.detail"
      @keydown.esc="dialog.detail = false"
      :fullscreen="dialog.fullscreen"
      width="700"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Detail Asset

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.detail = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text 
          class="mt-4">
          <v-skeleton-loader
            class="ma-auto"
            :loading="process.detail"
            type="article, list-item-three-line">
            <div>
              <div v-if="!process.detail && Object.keys(detail).length > 0">
                <div
                  class="font-weight-bold black--text mb-1">
                  Asset
                </div>

                <v-list
                  dense>
                  <v-list-item
                    class="pl-0"
                    style="border: 2px dashed #e0e0e0; border-radius: 10px;">
                    <v-list-item-avatar
                      class="mr-0">
                      <v-icon>mdi-rhombus-medium-outline</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title
                        class="mb-1">
                        {{ detail.item_name }}
                      </v-list-item-title>

                      <v-list-item-subtitle>
                        <div
                          class="d-flex align-start">
                          <div>
                            {{ detail.location_name }}
                          </div>

                          <v-spacer />

                          <div>
                            Pemeliharaan : 

                            <span
                              class="black--text">
                              {{ detail.maintenance_schedule_value }}
                              {{ detail.maintenance_schedule_type === 'daily' ? 'Hari' : detail.maintenance_schedule_type === 'weekly' ? 'Minggu' : detail.maintenance_schedule_type === 'monthly' ? 'Bulan' : detail.maintenance_schedule_type === 'annual' ? 'Tahun' : '-' }} Sekali
                            </span>
                          </div>
                        </div>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>

                <v-divider
                  class="mt-5 mb-3"
                  style="border-top: 2px dashed #e0e0e0;" />

                <v-row>
                  <v-col
                    cols="12"
                    md="3"
                    class="pb-2">
                    Tahun Pengadaan
                  </v-col>

                  <v-col
                    cols="12"
                    md="8"
                    class="pb-2">
                    : {{ detail.tahun_pengadaan !== '' ? detail.tahun_pengadaan : '-' }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                    md="3"
                    class="pt-0 pb-2">
                    Nilai Beli
                  </v-col>

                  <v-col
                    cols="12"
                    md="8"
                    class="pt-0 pb-2">
                    : {{ detail.nilai_beli | price }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                    md="3"
                    class="pt-0 pb-2">
                    PIC
                  </v-col>

                  <v-col
                    cols="12"
                    md="8"
                    class="pt-0 pb-2">
                    : {{ detail.pic_name }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                    md="3"
                    class="pt-0 pb-2">
                    Unit
                  </v-col>

                  <v-col
                    cols="12"
                    md="8"
                    class="pt-0 pb-2">
                    : {{ detail.unit_name }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                    md="3"
                    class="pt-0">
                    Pemilik
                  </v-col>

                  <v-col
                    cols="12"
                    md="8"
                    class="pt-0">
                    : {{ detail.owner }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                    md="3"
                    class="pt-0">
                    QR Kode
                  </v-col>

                  <v-col
                    cols="12"
                    md="8"
                    class="pt-0 d-flex align-start">
                    : 
                    
                    <div
                      @click="dialog.detail = false; dialog.qrcode = true;"
                      class="body-2 cursor-pointer">
                      <v-icon x-large color="black">mdi-qrcode</v-icon>
                    </div>
                  </v-col>
                </v-row>

                <v-divider
                  class="mt-3 mb-5"
                  style="border-top: 2px dashed #e0e0e0;" />

                <div
                  class="font-weight-bold black--text">
                  Lampiran
                </div>

                <v-row>
                  <v-col
                    v-for="(item, index) in detail.attachments_json_array"
                    :key="index"
                    cols="12"
                    md="4">
                    <v-card 
                      flat
                      height="200"
                      class="d-flex align-center justify-center cursor-pointer"
                          style="border-radius: 10px;
                                border: 2px solid #eaeaea; 
                                border-style: dashed;">
                      <v-img 
                        width="100%"
                        height="100%"
                        alt="visuality" 
                        :src="item.url !== '' ? item.url : require('@/assets/image/image_default.png')"
                        class="ma-auto"
                        style="border-radius: 10px;">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-skeleton-loader>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            @click="dialog.detail = false; dialog.fullscreen = false;">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col 
        cols="12"
        class="py-0">
        <v-card 
          flat 
          style="border: 1px solid #E0E0E0;">
          <v-card-text>
            <v-row>
              <v-col 
                cols="12" 
                md="8" 
                class="d-flex align-center">
                <!-- <div class="mr-3">
                  <v-btn
                    to="/asset/data/delete"
                    :color="set_color"
                    elevation="0"
                    style="border-radius: 10px;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center white--text">
                    <v-icon size="18">mdi-delete-sweep-outline</v-icon>

                    <span class="ml-1">
                      Berita Acara
                    </span>
                  </v-btn>
                </div> -->

                <div class="mr-3" v-if="selected.row.length === 1">
                  <v-btn 
                    @click="dialog.form = true; reset(selected.row[0]);"

                    elevation="0"
                    style="background: #2196f333; border-radius: 10px;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center blue--text">
                    <v-icon size="18">mdi-circle-edit-outline</v-icon>

                    <span class="ml-1">
                      Ubah
                    </span>
                  </v-btn>
                </div>

                <div class="mr-3" v-if="selected.row.length > 0">
                  <v-btn
                    @click="toUpdate()"

                    elevation="0"
                    style="background: #ff980033; border-radius: 10px;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center orange--text">
                    <v-icon size="18">mdi-calendar-multiselect-outline</v-icon>

                    <span class="ml-1">
                      Ubah Tanggal Pemeliharaan Terakhir
                    </span>
                  </v-btn>
                </div>

                <div class="mr-3" v-if="selected.row.length > 0">
                  <v-btn
                    @click="toDelete()"

                    elevation="0"
                    style="background: #f4403433; border-radius: 10px;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center red--text">
                    <v-icon size="18">mdi-delete-circle-outline</v-icon>

                    <span class="ml-1">
                      Hapus
                    </span>
                  </v-btn>
                </div>

                <div class="mr-3" v-if="selected.row.length === 1">
                  <v-btn
                    @click="dialog.detail = true; fetchDetail();"
                    elevation="0"
                    style="background: #e0e0e0; border-radius: 10px;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center text-second">
                    <v-icon size="18">mdi-information-outline</v-icon>

                    <span class="ml-1">
                      Detail
                    </span>
                  </v-btn>
                </div>
              </v-col>
                
              <v-col 
                cols="12" 
                md="4" 
                class="d-flex align-center justify-end">
                <v-text-field
                  filled
                  rounded
                  dense
                  single-line
                  hide-details
                  :color="set_color"
                  placeholder="Cari . . ."
                  vvvv-uppercase
                  append-icon="mdi-magnify"
                  clearable
                  v-model="search"
                  @click:clear="search = ''; fetch();"
                  v-on:keyup.enter="fetch()"
                  style="border-radius: 10px;">
                </v-text-field>

                <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="green"
                        elevation="0"
                        min-width="36"
                        class="text-capitalize white--text px-0"
                        style="border-radius: 10px;"
                        :disabled="process.download"
                        :loading="process.download"
                        @click="downloads()"
                        v-bind="attrs"
                        v-on="on">
                        <v-icon>mdi-table-arrow-down</v-icon>
                      </v-btn>
                    </template>
                    
                    <span>
                      Download Resume Aset
                    </span>
                  </v-tooltip>
                </div>

                <!-- FREEZE COLUMN -->
                <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        elevation="0"
                        outlined
                        dark
                        min-width="36"
                        :color="set_color"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on"
                        @click="dialog.freeze = true">
                        <v-icon size="18">mdi-table-split-cell</v-icon>
                      </v-btn>
                    </template>

                    <span>
                      Freeze
                    </span>
                  </v-tooltip>
                </div>

                <!-- HIDE COLUMN -->
                <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        elevation="0"
                        outlined
                        dark
                        min-width="36"
                        color="#7B7B7B"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on"
                        @click="dialog.hide = true">
                        <v-icon size="18">mdi-eye-off-outline</v-icon>
                      </v-btn>
                    </template>

                    <span>
                      Hide
                    </span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-data-table
            v-model="selected.row"
            ref="table-grid"
            class="table-grid"
            :height="`calc(100vh - ${pagination.total_data > 0 ? '314px' : '242px'})`"
            :show-select="checkbox"
            :single-select="false"
            :loading="process.load"
            loading-text="Sedang memuat data . . ."
            loader-height="5"
            no-results-text="Belum ada data"
            :options.sync="options"
            :headers="configHeaders"
            :items="list"
            :item-class="itemRowBackground"
            :items-per-page="100"
            item-key="id"
            @click:row="rowClick"
            @toggle-select-all="handleToggleAll($event)"
            @dblclick:row="doubleClick"
            hide-default-footer>
            <template 
              v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
              v-slot:[`item.${header.value}`]="{ value, index }">
              <div
                v-bind:key="header.value">
                <div v-if="header.format !== 'qrcode' && header.format !== 'schedule' && header.format !== 'bigger'">
                  {{ rowFormat(header.format, value) }} 
                </div>

                <div v-if="header.format === 'qrcode'">
                  <div
                    @click="dialog.qrcode = true"
                    class="body-2 cursor-pointer">
                    <v-icon large color="black">mdi-qrcode</v-icon>
                  </div>
                </div>

                <div v-if="header.format === 'schedule'">
                  <div
                    class="body-2">
                    {{ list[index].maintenance_schedule_value }}
                    {{ list[index].maintenance_schedule_type === 'daily' ? 'Hari' : list[index].maintenance_schedule_type === 'weekly' ? 'Minggu' : list[index].maintenance_schedule_type === 'monthly' ? 'Bulan' : list[index].maintenance_schedule_type === 'annual' ? 'Tahun' : '-' }} Sekali
                  </div>
                </div>

                <!-- <div v-if="header.format === 'bigger'"
                  :class="list[index].next_maintenance_date <= dateNow ? 'red--text' : ''">
                  {{ list[index].next_maintenance_date | date }}
                </div> -->

                <div v-if="header.format === 'bigger'">
                  {{ list[index].next_maintenance_date | date }}
                </div>
              </div>
            </template>

            <template v-slot:[`item.index`]="{ index }">
              {{ lastIndex + index }}
            </template>

            <v-progress-linear 
              v-show="process.load" 
              slot="progress" 
              color="white" 
              indeterminate>
            </v-progress-linear>
          </v-data-table>

          <pagination v-if="pagination.total_data > 0"
            @changePage="fetch($event)" 
            @reloadPage="fetch($event)" 
            :model="pagination"/>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        dateNow: moment().format('YYYY-MM-DD'),
        checkbox: true,
        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,

          form: false,
          delete: false,

          update_pemeliharaan: false,

          qrcode: false,

          detail: false
        },

        search: '',

        selected: {
          row: [],
          freeze: [],

          delete: [],
          update_pemeliharaan: []
        },

        detail: {},

        options: {},
        headers: [],

        list: [],
        pagination: {},
        lastIndex: 0,
        limit: 20,

        form: {
          id: '',
          code_manual: '',
          location_name: '',
          pic_name: '',

          nilai_beli: 0,
          tahun_pengadaan: new Date().getFullYear(),

          attachments_json_array: []
        },

        form_pemeliharaan: {
          last_maintenance_date: '',
          maintenance_schedule_type: '',
          maintenance_schedule_value: '',
          
          details: []
        },

        form_delete: {
          desc: '',
          date: '',
          attachments_json_array: [],
          
          details: []
        },

        picker: {
          last: false,
          delete: false
        },

        upload: {
          image: null
        },
        
        process: {
          load: false,
          form: false,

          delete: false,

          image: false,

          download: false,

          detail: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue'),
      uploadfolder: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue')
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },
      months () {
        let numb = new Date().getMonth() + 1
        
        this.filter.month = numb < 10 ? `0${numb}` : `${numb}`

        return [
          {
            text: 'Januari',
            value: '01'
          },
          {
            text: 'Februari',
            value: '02'
          },
          {
            text: 'Maret',
            value: '03'
          },
          {
            text: 'April',
            value: '04'
          },
          {
            text: 'Mei',
            value: '05'
          },
          {
            text: 'Juni',
            value: '06'
          },
          {
            text: 'Juli',
            value: '07'
          },
          {
            text: 'Agustus',
            value: '08'
          },
          {
            text: 'September',
            value: '09'
          },
          {
            text: 'Oktober',
            value: '10'
          },
          {
            text: 'November',
            value: '11'
          },
          {
            text: 'Desember',
            value: '12'
          }
        ]
      },
      years () {
        let max = new Date().getFullYear(), min = max - 10, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },

      years () {
        let max = new Date().getFullYear(), min = max - 10, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      }
    },
    watch: {
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          this.fetch(pagination)
        },
        deep: true
      },

      'upload.image': {
        handler: function () {
          if (this.upload.image) {
            this.process.image = this.upload.image.process

            if (!this.process.image) {
              // CALLBACK FROM UPLOAD IMAGE

              if (this.dialog.form) {
                this.form.attachments_json_array.push({
                  url: this.upload.image.fileuri,
                  size: this.upload.image.filesize,
                  title: this.upload.image.filename,
                  mimetype: this.upload.image.filemime,
                  extension: this.upload.image.filemime.split('/')[1]
                })
              }

              if (this.dialog.delete) {
                this.form_delete.attachments_json_array.push({
                  url: this.upload.image.fileuri,
                  size: this.upload.image.filesize,
                  title: this.upload.image.filename,
                  mimetype: this.upload.image.filemime,
                  extension: this.upload.image.filemime.split('/')[1]
                })
              }
            }
          }
        },
        deep: true
      }
    },
    mounted () {
      // this.fetch()
    },
    methods: {
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value.split('.')[0]
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          },00`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].title)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
          // data = value.length > 0 ? moment(value).format(format === 'date' ? 'D MMM, YYYY' : format === 'time' ? 'HH:mm' : 'D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'question') {
          data = value
        } else if (format === 'qrcode') {
          data = value
        } else if (format === 'schedule') {
          data = value
        } else if (format === 'bigger') {
          data = value
        } else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }
        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },
      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: this.options.sortBy.length < 1 ? 'id' : this.options.sortBy[0],
          order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',

          search: this.search,

          item_id: this.$route.params.id
        }

        this.selected.row = []

        await get('assets/v2/item_detail/data', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.headers = [
              {
                text: '#No',
                width: '75px',
                value: 'index',
                sortable: false,
                freeze: true,
                hide: false,
                align: 'center'
              },
              {
                text: 'Kode Asset',
                width: '200px',
                value: 'code',
                freeze: false,
                hide: false
              },
              {
                text: 'Kode Asset Manual',
                width: '200px',
                value: 'code_manual',
                freeze: false,
                hide: false
              },
              {
                text: 'Nama Asset',
                width: '300px',
                value: 'item_name',
                freeze: false,
                hide: false
              },
              {
                text: 'Tahun Pengadaan',
                width: '200px',
                value: 'tahun_pengadaan',
                freeze: false,
                hide: false
              },
              {
                text: 'Nilai Beli',
                width: '200px',
                value: 'nilai_beli',
                freeze: false,
                hide: false,
                align: 'end',
                format: 'number'
              },
              {
                text: 'Lokasi',
                width: '200px',
                value: 'location_name',
                freeze: false,
                hide: false
              },
              {
                text: 'PIC',
                width: '200px',
                value: 'pic_name',
                freeze: false,
                hide: false
              },
              {
                text: 'QR Kode',
                width: '200px',
                value: 'id',
                freeze: false,
                hide: false,
                align: 'center',
                format: 'qrcode'
              },
              {
                text: 'Tanggal Pemeliharaan Terakhir',
                width: '250px',
                value: 'last_maintenance_date',
                freeze: false,
                hide: false,
                format: 'date'
              },
              {
                text: 'Tanggal Pemeliharaan Berikutnya',
                width: '260px',
                value: 'next_maintenance_date',
                freeze: false,
                hide: false,
                format: 'bigger'
              },
              {
                text: 'Jadwal Pemeliharaan',
                width: '300px',
                value: 'maintenance_schedule_type',
                freeze: false,
                hide: false,
                format: 'schedule'
              }
            ]
            
            this.list = res.results.data
            this.pagination = res.results.pagination

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1

            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },
      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: ${this.set_color};
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: ${this.set_color};
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      reset (item) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: item !== undefined ? item.id : '',
          code_manual: item !== undefined ? item.code_manual : '',
          location_name: item !== undefined ? item.location_name : '',
          pic_name: item !== undefined ? item.pic_name : '',

          nilai_beli: item !== undefined ? item.nilai_beli : 0,
          tahun_pengadaan: item !== undefined ? item.tahun_pengadaan : new Date().getFullYear(),

          attachments_json_array: item !== undefined ? item.attachments_json_array : []
        }

        this.process.form = false

        this.message.error = ''
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true
          
          // SAVE TO REST API
          await post('assets/v2/item_detail/update', {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      toUpdate () {
        this.selected.update_pemeliharaan = []

        for (let i in this.selected.row) {
          this.selected.update_pemeliharaan.push(parseInt(this.selected.row[i].id))
        }

        this.dialog.update_pemeliharaan = true


        // DATA PEMELIHRAAN
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form_pemeliharaan = {
          last_maintenance_date: '',
          maintenance_schedule_type: '',
          maintenance_schedule_value: '',
          
          details: []
        }

        this.process.form = false

        this.message.error = ''
      },

      async updates () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          this.form_pemeliharaan.details = []

          let data = this.selected.update_pemeliharaan

          data.map(obj =>  {
            this.form_pemeliharaan.details.push({
              id: obj,
              last_maintenance_date: this.form_pemeliharaan.last_maintenance_date,
              maintenance_schedule_type: this.form_pemeliharaan.maintenance_schedule_type,
              maintenance_schedule_value: this.form_pemeliharaan.maintenance_schedule_value
            })
          })

          // SAVE TO REST API
          await post('assets/v2/item_detail/update_many_maintenance_schedule', {
            data: this.form_pemeliharaan
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.update_pemeliharaan = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      toDelete () {
        this.selected.delete = []

        let detail_item = []

        for (let i in this.selected.row) {
          this.selected.delete.push(parseInt(this.selected.row[i].id))

          detail_item.push({
            id: parseInt(this.selected.row[i].id),
            code: this.selected.row[i].code,
            code_manual: this.selected.row[i].code_manual
          })
        }

        this.dialog.delete = true

        // HAPUS
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form_delete = {
          desc: '',
          date: '',
          attachments_json_array: [],
          
          details: detail_item
        }

        this.process.form = false

        this.message.error = ''
      },

      async deletes () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true
          
          console.log(this.form_delete)

          // SAVE TO REST API
          await post('assets/v2/ba_delete/add', {
            data: this.form_delete
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.delete = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.$router.push('/asset/data/delete?tab=1')
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      async downloads () {
        this.message.error = ''
        
        this.process.download = true

        await axios({
          url: `${process.env.VUE_APP_API_URL}assets/v2/item_detail/export`,
          method: 'GET',
          responseType: 'blob', // important,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          },
          params: {
            item_id: this.$route.params.id
          }
        }).then((response) => {
          let res = response

          if (res.status === 200) {
            this.process.download = false
            
            this.dialog.snackbar = true
            this.message.success = 'Berhasil download resume asset'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `Amanata-${moment().format('DD-MMMM-YYYY', 'id')}-${moment().format('HH:mm:ss', 'id')}.xls`)
            document.body.appendChild(link)
            link.click()
          } else {
            this.process.download = false
            this.message.error = res.message
          }
        })
      },

      async fetchDetail () {
        this.process.detail = true

        let params = {
          id: this.selected.row[0].id
        }

        await get('assets/v2/item_detail/detail', { params })
        .then(response => {
          let res = response.data

          this.process.detail = false
            
          if (res.status === 200) {
            this.detail = res.results.data
          }
        })
      },

      itemRowBackground: function (item) {
        return item.next_maintenance_date <= this.dateNow ? 'style-1' : 'style-2'
      }
    }
  }
</script>

<style>
  .table-grid table thead > tr > th, .table-grid table tbody > tr > td {
    position: sticky;
    position: -webkit-sticky;
    border-right: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
  }

  .table-grid table > tbody > tr > td:nth-child(1) {
    left: 0; 
    z-index: 1;
  }

  .table-grid table > tbody > tr:nth-of-type(even) .text-start, table > tbody > tr:nth-of-type(even) .text-center, table > tbody > tr:nth-of-type(even) .text-end {
    background: #fafafa;
  }

  .table-grid table > tbody > tr:nth-of-type(odd) .text-start, table > tbody > tr:nth-of-type(odd) .text-center, table > tbody > tr:nth-of-type(odd) .text-end {
    background: white;
  }

  .style-1 td {
    background: #FFCDD2 !important;
  }
  .style-2 td {
    background: white !important;
  }
</style>